<template>
  <div>
    <v-dialog v-model="dialog.dialogAddOrderItem" max-width="1000px" eager>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0"
                    outlined
                    name="input-7-4"
                  :label="$t('รหัสการสั่งตรวจ')"
                  v-model="newOrderItemID"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('ชื่อการสั่งตรวจ')"
                  v-model="newOrderItemDesc"
                ></v-text-field>
              </v-col> 
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('ชื่อเล่น')"
                  v-model="newNickName"
                ></v-text-field>
              </v-col> 
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn outlined color="success" @click="addOrderItem(newOrderItemID,newOrderItemDesc,newNickName)">{{$t('save')}}</v-btn>
            <v-btn outlined color="error" @click="closeAddnew">{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogAddEdit" max-width="1000px" eager>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0"
                  outlined
                  name="input-7-4"
                  :label="$t('รหัสการสั่งตรวจ')"
                  v-model="vDataTable.editedItem.order_item_id"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('ชื่อการสั่งตรวจ')"
                  v-model="vDataTable.editedItem.order_item_desc"
                ></v-text-field>
              </v-col> 
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  dense
                  hide-details
                  outlined
                  v-model="vDataTable.editedItem.laboratory_skey"
                  :items="laboratoryList"
                  :search-input.sync="custName"
                  item-text="sub_category_desc"
                  item-value="laboratory_skey"
                >
                  <template v-slot:label>
                    <span class="input__label text-title">{{ $t('หน่วยงาน') }}</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('method')"
                  v-model="vDataTable.editedItem.method"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('ประเภทสิ่งส่งตรวจ')"
                  v-model="vDataTable.editedItem.specimen_type_desc"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('Specimen type code')"
                  v-model="vDataTable.editedItem.specimen_type_cd"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('ข้อควรระวัง')"
                  v-model="vDataTable.editedItem.delivery_caution"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('ค่าอ้างอิง')"
                  v-model="vDataTable.editedItem.sensitivity_detection"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('ราคาสามัญ')"
                  v-model="vDataTable.editedItem.standard_price"
                  type="money"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('special_price')"
                  v-model="vDataTable.editedItem.special_price"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('patho_lab_price')"
                  v-model="vDataTable.editedItem.patho_lab_price"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('test_day')"
                  v-model="vDataTable.editedItem.test_day"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('indicator')"
                  v-model="vDataTable.editedItem.indicator"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('report_normal')"
                  v-model="vDataTable.editedItem.report_normal"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('report_repeat')"
                  v-model="vDataTable.editedItem.report_repeat"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('report_urgent')"
                  v-model="vDataTable.editedItem.report_urgent"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('lab_group')"
                  v-model="vDataTable.editedItem.lab_group"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('remark')"
                  v-model="vDataTable.editedItem.remark"

                ></v-textarea>
              </v-col>
              <v-col cols="2" class="mt-0 pa-0">
                <!-- <v-checkbox label="Foo" input-value="1"></v-checkbox> -->
                <v-checkbox outlined dense hide-details
                  false-value="N"
                  true-value="Y"
                  ref="checkBoxIHCSpecialStaining"
                  v-model="vDataTable.editedItem.active">
                  <template v-slot:label>
                    <div><span class='text--primary'>Active</span></div>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn outlined color="success" @click="save">{{$t('save')}}</v-btn>
            <v-btn outlined color="error" @click="close">{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          {{progressMessage}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogAddTestItem" max-width="1000px" max-height="80%" eager>
      <v-card flat>
        <v-card-title>
          <v-toolbar dense flat color="white">
            <v-toolbar-title>{{$t('Add Test Item')}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card-title>
        <v-data-table
          v-model="vDataTableTestItem.selected"
          :headers="testItemHeaders"
          :items="vDataTableTestItem.data"
          :search="vDataTableTestItem.search"
          fixed-header
          :page.sync="vDataTableTestItem.options.page"
          :itemsPerPage.sync="vDataTableTestItem.options.itemsPerPage"
          :options.sync="vDataTableTestItem.options"
          :footer-props="{
            itemsPerPageText: $t('itemsPerPageText'),
            itemsPerPageAllText: $t('itemsPerPageAllText'),
            showFirstLastPage: true,
            showCurrentPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
          item-key="test_item_skey"
          class="fill-height"
          @click:row="addTestToOrder"
          >
        </v-data-table>
      </v-card>
    </v-dialog>
    <v-data-table
      v-model="vDataTable.selected"
      :headers="headers"
      :items="vDataTable.data"
      :search="vDataTable.search"
      show-select
      fixed-header
      :page.sync="vDataTable.options.page"
      :itemsPerPage.sync="vDataTable.options.itemsPerPage"
      :options.sync="vDataTable.options"
      :height="$vuetify.breakpoint.height - 123 - offsetAppBar"
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="order_item_skey"
      class="fill-height"
      show-expand single-expand
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" style="background-color: #f0f0f0; padding: 3;">
          <v-card class="ma-3" style="overflow-x: auto; ">
            <v-data-table
              fixed-header
              :headers="addTestItemHeaders"
              :items="item.test_items"
              class="elevation-1"
              hide-default-footer
              style="margin: auto;"
              dense>
              <template v-slot:item.actions="{ item: test_items }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="red" small class="mr-2" v-bind="attrs" v-on="on" @click.stop="deleteOrderTestItem(test_items, item)">delete</v-icon>
                  </template>
                  <span>delete</span>
                </v-tooltip>
              </template>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Test Item</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newTestItem(item)">
                    <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>{{$t('WpCustomer.buttonnewCustomer')}}
                  </v-btn>
                </v-toolbar>
              </template>
            </v-data-table>
          </v-card>
        </td>
      </template>
      <template v-slot:header.data-table-select="{ on, props }">
        <p>{{  on, props  }}</p>
        <tr>
          <td>
            <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
          </td>
          <td v-if="vDataTable.selected.length > 0">
            {{ vDataTable.selected.length }}
          </td>
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{$t('WpOrderItem.OrderItemTitle')}}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <label>File
            <!-- <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/> -->
            <input type="file" @change="handleFileUpload">
          </label>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" style="text-transform: capitalize" @click="ImportExcelToDbConfirm()">
            {{$t('import')}}
          </v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="ExportExcelLab">
            {{$t('export excel')}}
          </v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>   
          <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newItem()">
            <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>{{$t('WpOrderItem.buttonnewOrderItem')}}
          </v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" @click="checkDeleteselected" style="text-transform: capitalize">
            <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>{{$t('WpOrderItem.buttonDeleteOrderItem')}}
          </v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" style="text-transform: capitalize" @click="retrieveWpOrderItem(appName)">
            <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="30"/>{{$t('find')}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field outlined dense hide-details v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="teal" class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="pink" class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirm(item)">delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
      <template v-slot:item.data-table-no="{ item, index }">
        {{ ((vDataTable.options.page - 1) * vDataTable.options.itemsPerPage) + index + 1 }}
      </template>
      <template v-slot:item.active="{ item }">
        <v-icon v-if="item.active == 'Y'" large color="green">
          {{ item.active == 'Y' ? 'mdi-checkbox-marked-circle' : 'mdi-close-circle' }}
        </v-icon>
        <v-icon v-if="item.active != 'Y'" large color="red">
          {{ item.active == 'Y' ? 'mdi-checkbox-marked-circle' : 'mdi-close-circle' }}
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-alert type="info" border="bottom" colored-border elevation="2">
          {{$t('noData')}}
        </v-alert>
      </template>
      <template v-slot:no-results>
        <v-alert type="warning">
          {{ stringFormat($t('searchNotFound'), vDataTable.search) }}
        </v-alert>
      </template>
      <template v-slot:footer>
        <tr class="sticky-table-footer" style="position: absolute">
          <td>Selected({{ vDataTable.selected.length }})s</td> 
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import Base64Binary from 'base64-arraybuffer'
import { VueEditor, Quill } from 'vue2-editor'
/* import { consoleLog } from '../node_modules-/echarts/lib/util/log' */
var Keyboard = Quill.import('modules/keyboard')
class CustomKeyboard extends Keyboard {
  static DEFAULTS = {
    ...Keyboard.DEFAULTS,
    bindings: {
      ...Keyboard.DEFAULTS.bindings,
      ['list autofill']: undefined,
    }
  }
}
Quill.register('modules/keyboard', CustomKeyboard)
export default {
  components: {
    VueEditor,
  },

  props: ['parentComponent'],

  data () {
    return {
      utils: require('@/utils'),
      stringFormat: require('string-format'),
      appName: process.env.VUE_APP_DB_APP_NAME,
      rules: {
        winName: value => {
          const pattern = /^[a-zA-Z0-9$@$!%*?&#^-_. +]+$/
          return pattern.test(value) || 'Invalid Window Name'
        },
      },
      dialog: {
        dialogProgress: false,
        dialogAddEdit: false,
        dialogLanguage: false,
        dialogAddOrderItem: false,
        dialogAddTestItem: false,
      },
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      vDataTableTestItem: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      progressMessage: '',
      languages: [],
      languageEdit: true,
      vueEditorOrganGross: 'vue-editorOrganGrossCustomHeight200',
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        /* [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], */
        /* [{ list: 'ordered' }, { list: 'check' }], */
        /* [{ indent: '-1' }, { indent: '+1' }], */
        [{ color: [] }],
        ['clean']
      ],
      editorSettings: {
        fomats: [
          'background',
          'bold',
          'color',
          'font',
          'code',
          'italic',
          'link',
          'size',
          'strike',
          'script',
          'underline',
          'blockquote',
          'header',
          'indent',
          'align',
          'direction',
          'code-block',
          'formula',
          'image',
          'video'
        ],
      },
      sheets: [],
      file: '',
      selectedFile: null,
      laboratoryList: [],
      // add new order item
      newNickName: '',
      newOrderItemID: '',
      newOrderItemDesc: '',
    }
  },

  computed: {
    ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
    formTitle () {
      return this.vDataTable.editedIndex === -1 ? this.$t('WpOrderItem.newOrderItem') : this.$t('WpOrderItem.newOrderItem')
    },
    formLanguageTitle () {
      return this.vDataTable.editedLanguageIndex === -1 ? this.$t('WpOrderItem.newOrderItemLanguage') : this.$t('WpOrderItem.editOrderItemLanguage')
    },
    headers () {
      return [
        { text: '', align: 'center', value: 'data-table-select' },
        { text: 'skey', align: 'left', value: 'order_item_skey', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('ชื่อห้องปฏิบัติการ'), value: 'sub_category_desc', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: this.$t('รหัส'), value: 'order_item_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('ชื่อการสั่งตรวจ'), value: 'order_item_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('method'), value: 'method', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('ประเภทสิ่งส่งตรวจ'), value: 'specimen_type_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Specimen Type Code'), value: 'specimen_type_cd', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('ราคา'), value: 'medium_price', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: 'Active', value: 'active', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    testItemHeaders () {
      return [
        { text: this.$t('Test Item Skey'), value: 'test_item_skey', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Test Item ID'), value: 'test_item_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Test Item Desc'), value: 'test_item_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    addTestItemHeaders () {
      return [
        { text: this.$t('Seq'), value: 'seq', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Test Item Skey'), value: 'test_item_skey', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Test Item ID'), value: 'test_item_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Test Item Desc'), value: 'test_item_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Remark'), value: 'remark', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    subHeaders () {
      return [
        { text: this.$t('navWindow.windowName'), value: 'win_name' },
        { text: this.$t('createUser'), value: 'create_user_id' },
      ]
    },
    offsetAppBar () {
      // return this.getShowAppBar ? 0 : this.getAppBarHeight
      return this.getShowAppBar ? this.getAppBarHeight : 0
    },
  },

  watch: {
    'dialog.dialogAddEdit' (val) {
      val || this.close()
    }
  },

  async created () {
    await this.retrieveWpOrderItem(this.appName)
    await this.retrieveWpLaboratory(this.appName)
    await this.retrieveWpTestItem(this.appName)
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    /* getIp () {
      console.log('getip')
      this.axios.post('https://api.db-ip.c../free/self', {
      })
        .then(response => {
          console.log(response, 'response')
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    }, */
    selectLanguage (language) {
    },
    initialize () {
      this.vDataTable.selected = []
      this.vDataTable.editedIndex = -1
      this.vDataTable.editedItem = {
        win_name: '',
        window_comment: ''
      }
      this.vDataTable.defaultItem = {
        win_name: '',
        window_comment: ''
      }
    },
    newOrderItemLanguage (item) {
      this.vDataTable.editedItem = Object.assign({}, item)
      // this.dialogLanguage = true
      this.languageEdit = false
    },
    expandCollapseNode (expand) {
      if (expand) {
        this.vDataTable.expanded = this.vDataTable.data
      } else {
        this.vDataTable.expanded = []
      }
    },
    findCopyHeader (skey) {
      return this.vDataTable.data.find(function (x) {
        return (x.skey === skey)
      })
    },
    findLanguage (skey) {
      return this.vDataTable.data.find(function (x) {
        return (x.skey === skey)
      }).mt_guarantee_master_language
    },
    findNodeSelectedLanguage (skey) {
      return this.vDataTable.data.find(function (x) {
        return (x.skey === skey)
      }).selectedLanguage
    },
    retrieveLanguage () {
      this.axios.post(process.env.VUE_APP_API + '/wp_order_item/retrieveLanguage' + process.env.VUE_APP_DATABASE_TYPE, {
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.languages = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async retrieveWpOrderItem (appName) {
      console.log('retrieveWpOrderItem')
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/orderItem/retrieveWpOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
        cust_skey: localStorage.getItem('cust_skey')
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.data = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async retrieveWpTestItem (appName) {
      console.log('retrieveWpOrderItem')
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/orderItem/retrieveTestItem' + process.env.VUE_APP_DATABASE_TYPE, {
        cust_skey: localStorage.getItem('cust_skey')
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTableTestItem.data = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async saveAddnew () {
      await addOrderItem(this.newOrderItemID, newOrderItemDesc, newNickName).then(res => {
        console.log(res)
      })
    },
    closeAddnew () {
      this.dialog.dialogAddOrderItem = false
    },
    async addOrderItem (orderItemId, orderItemDesc, NickName) {
      if (!orderItemId) {
        await this.$swal({type: 'error', title: 'กรุณาระบุรหัสการทดสอบ'})
        return
      }
      if (!orderItemDesc) {
        await this.$swal({type: 'error', title: 'กรุณาระบุชื่อการทดสอบ'})
        return
      }
      await this.axios.post(process.env.VUE_APP_API + '/orderItem/addOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
        order_item_id: orderItemId,
        order_item_desc: orderItemDesc,
        nickname: NickName,
        user: localStorage.getItem('username')
      })
        .then(response => {
          if (response.data.isSuccess) {
            if (response.data.data[0].reasonValue === 1) {
              this.retrieveWpOrderItem()
              this.$swal({type: 'success', title: response.data.data[0].reasonText, showConfirmButton: false, timer: 1500})
              this.dialog.dialogAddOrderItem = false
            } else {
              this.$swal({type: 'error', title: response.data.data[0].reasonText, showConfirmButton: false, timer: 1500})
            }
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async updateOrderItem (orderItemSkey, orderItemId, orderItemName, method, specimenType, specimenTypeCode, deliveryCaution,
          sensitivityDetection, standardPrice, specialPrice, pathoLabPrice, testDay, indicator, reportNormal,
          reportRepeat, reportUrgent, labGroup, remark, active) {
      if (!orderItemId) {
        await this.$swal({type: 'error', title: 'กรุณาระบุรหัสการทดสอบ'})
        return
      }
      if (!orderItemName) {
        await this.$swal({type: 'error', title: 'กรุณาระบุชื่อการทดสอบ'})
        return
      }
      await this.axios.post(process.env.VUE_APP_API + '/wp_order_item/updateOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
        order_item_skey: orderItemSkey,
        order_item_id: orderItemId,
        order_item_name: orderItemName,
        method: method,
        specimen_type: specimenType,
        specimen_type_code: specimenTypeCode,
        delivery_caution: deliveryCaution,
        sensitivity_detection: sensitivityDetection,
        standard_price: standardPrice,
        special_price: specialPrice,
        patho_lab_price: pathoLabPrice,
        test_day: testDay,
        indicator: indicator,
        report_normal: reportNormal,
        report_repeat: reportRepeat,
        report_urgent: reportUrgent,
        lab_group: labGroup,
        remark: remark,
        active: active
      })
        .then(response => {
          if (response.data.isSuccess) {
            Object.assign(this.vDataTable.data[this.vDataTable.editedIndex], this.vDataTable.editedItem)
            this.retrieveWpOrderItem()
            this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
            this.dialog.dialogAddEdit = false
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async asyncForEach (array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    },
    checkDeleteselected () {
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: this.$t('WpOrderItem.confirmDeleteSelected'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('WpOrderItem.messageDeleteNotSelected')})
      }
    },
    async deleteSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      var del = []
      await this.asyncForEach(this.vDataTable.selected, async function (x) {
        this.progressMessage = this.stringFormat(this.$t('WpOrderItem.progressMessageDelete'), x.order_item_desc)
        var val = await this.deleteNode(x)
        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))
      for (const x in del) {
        this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
      }

      this.dialog.dialogProgress = false
    },
    async deleteNode (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var orderItemID = item.order_item_id
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/orderItem/deleteWpOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
          order_item_id: orderItemID
        })
          .then(async response => {
            if (response.data.isSuccess) {
              this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
              this.retrieveWpOrderItem(this.appName)
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    newItem () {
      this.newOrderItemID = ''
      this.newOrderItemDesc = ''
      this.newNickName = ''
      this.dialog.dialogAddOrderItem = true
    },
    editItem (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.dialog.dialogAddEdit = true
    },
    newTestItem (item) {
      this.dialog.dialogAddTestItem = true
      this.current_order_item_skey = item.order_item_skey
    },
    async addTestToOrder (item) {
      this.dialog.dialogProgress = true
      console.log(item.test_item_skey, this.current_order_item_skey, 'testnutt')
      await this.axios.post(process.env.VUE_APP_API + '/orderItem/addTestToOrder' + process.env.VUE_APP_DATABASE_TYPE, {
        order_item_skey: this.current_order_item_skey,
        test_item_skey: item.test_item_skey
      }).then(res => {
        if (res.data.isSuccess === true) {
          this.$swal({type: 'success', title: 'สำเร็จ', timer: 1500})
        } else {
          this.$swal({type: 'error', title: 'ไม่สำเร็จ', timer: 1500})
        }
      })
      this.retrieveWpOrderItem(this.appName)
      this.dialog.dialogAddTestItem = false
      this.dialog.dialogProgress = false
    },
    async deleteOrderTestItem (testItem, item) {
      this.dialog.dialogProgress = true
      await this.axios.post(process.env.VUE_APP_API + '/orderItem/deleteOrderTestItem' + process.env.VUE_APP_DATABASE_TYPE, {
        order_item_skey: item.order_item_skey,
        test_item_skey: testItem.test_item_skey
      }).then(res => {
        if (res.data.isSuccess === true) {
          this.$swal({type: 'success', title: 'สำเร็จ', timer: 1500})
        } else {
          this.$swal({type: 'error', title: 'ไม่สำเร็จ', timer: 1500})
        }
      })
      this.retrieveWpOrderItem(this.appName)
      this.dialog.dialogAddTestItem = false
      this.dialog.dialogProgress = false
    },
    editLanguageItem (item) {
      this.languageEdit = true
      this.vDataTable.editedLanguageIndex = this.findLanguage(item.skey).indexOf(item)
      this.vDataTable.editedLanguageItem = Object.assign({}, item)
      this.dialog.dialogLanguage = true
    },
    async deleteItemConfirm (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat(this.$t('WpOrderItem.confirmDelete'), item.order_item_desc),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteNode(item)
          if (val !== undefined) {
            if (this.vDataTable.selected.indexOf(this.vDataTable.editedItem) >= 0) {
              this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(this.vDataTable.editedItem), 1)
            }
          }
          this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
          this.vDataTable.editedIndex = -1
        }
      })
    },
    close () {
      this.dialog.dialogAddEdit = false
      this.$nextTick(() => {
        this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
        this.vDataTable.editedIndex = -1
      })
    },
    async save () {
      if (this.vDataTable.editedIndex > -1) {
        await this.updateOrderItem(this.vDataTable.editedItem.order_item_skey,
          this.vDataTable.editedItem.order_item_id,
          this.vDataTable.editedItem.order_item_desc,
          this.vDataTable.editedItem.method,
          this.vDataTable.editedItem.specimen_type_desc,
          this.vDataTable.editedItem.specimen_type_cd,
          this.vDataTable.editedItem.delivery_caution,
          this.vDataTable.editedItem.sensitivity_detection,
          this.vDataTable.editedItem.standard_price,
          this.vDataTable.editedItem.special_price,
          this.vDataTable.editedItem.patho_lab_price,
          this.vDataTable.editedItem.test_day,
          this.vDataTable.editedItem.indicator,
          this.vDataTable.editedItem.report_normal,
          this.vDataTable.editedItem.report_repeat,
          this.vDataTable.editedItem.report_urgent,
          this.vDataTable.editedItem.lab_group,
          this.vDataTable.editedItem.remark,
          this.vDataTable.editedItem.active
          ).then(res => {
            console.log(res, 'tee')
          })
        this.close()
      } else {
        await this.addOrderItem(this.vDataTable.editedItem.order_item_id,
          this.vDataTable.editedItem.order_item_desc,
          this.vDataTable.editedItem.method,
          this.vDataTable.editedItem.specimen_type_desc,
          this.vDataTable.editedItem.specimen_type_cd,
          this.vDataTable.editedItem.delivery_caution,
          this.vDataTable.editedItem.sensitivity_detection,
          this.vDataTable.editedItem.standard_price,
          this.vDataTable.editedItem.special_price,
          this.vDataTable.editedItem.patho_lab_price,
          this.vDataTable.editedItem.test_day,
          this.vDataTable.editedItem.indicator,
          this.vDataTable.editedItem.report_normal,
          this.vDataTable.editedItem.report_repeat,
          this.vDataTable.editedItem.report_urgent,
          this.vDataTable.editedItem.lab_group,
          this.vDataTable.editedItem.remark,
          this.vDataTable.editedItem.active
          )
      }
    },
    pickFileInsert (image) {
      this.$refs.imageInsert.click()
    },
    handleFileSelectInsert: function (event) {
      var input = event.target
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          var binaryData = e.target.result
          this.vDataTable.editedItem.filename = input.files[0].name
          this.vDataTable.editedItem.picture_base64 = window.btoa(binaryData)
        }
        reader.readAsBinaryString(input.files[0])
      }
    },
    async copyHeader () {
      console.log(this.vDataTable.editedItem.skey, 'copyHeader')
      console.log(this.findCopyHeader(this.vDataTable.editedItem.skey), 'copyHeader2')
      const guarantee = await this.findCopyHeader(this.vDataTable.editedItem.skey)
      console.log(this.findCopyHeader(this.vDataTable.editedItem.skey).guarantee_name, 'this.findCopyHeader(this.vDataTable.editedItem.skey).guarantee_name')
      this.vDataTable.editedLanguageItem.guarantee_name = await this.findCopyHeader(this.vDataTable.editedItem.skey).guarantee_name
      this.vDataTable.editedLanguageItem.guarantee_detail = await this.findCopyHeader(this.vDataTable.editedItem.skey).guarantee_detail
      console.log(this.vDataTable.editedLanguageItem, 'this.vDataTable.editedLanguageItem')
    },
    handleFileUpload (event) {
      this.selectedFile = event.target.files[0]
      console.log(this.selectedFile.name, 'this.selectedFile.name')
    },
    // handleFileUpload () {
    //   this.file = this.$refs.file.files[0]
    // },
    async ImportExcelToDbConfirm () {
      console.log(this.selectedFile, 'this.selectedFile')
      if (this.selectedFile) {
        this.$swal({
          text: this.stringFormat('ต้องการนำเข้าข้อมูลหรือไม่', this.selectedFile.name),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then(async (result) => {
          if (result) {
            await this.ImportExcelToDb()
          }
        })
      } else {
        this.$swal({type: 'warning', title: 'กรุณาเลือกไฟล์'})
      }
    },

    async ImportExcelToDb () {
      console.log('ImportExcelToDb')
      let formData = new FormData()
      formData.append('file', this.selectedFile)
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/wp_order_item/ImportExcelToDb', formData,
        {
          headers: {'Content-Type': 'multipart/form-data'}
        }
      ).then(response => {
        if (response.data.isSuccess) {
          /* this.sheets = response.data.sheet */
          console.log(response.data, 'response.data')
          console.log(this.sheets, 'this.sheets')
          /* for (var i = 0; i < this.sheets.length; i++) {
            this.sheets[i].headers = []
            for (var val in this.sheets[i].data[0]) {
              var colName = (val === '0' ? '#' : this.toColumnName(parseInt(val)))
              if (val !== 'Row_Null') {
                this.sheets[i].headers.push({text: val, value: val, align: 'center'})
              }
            }
          } */
          console.log(response.data.reasonText, 'response.data.reasonText')
          this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
          this.retrieveWpOrderItem(this.appName)
        } else {
          this.$swal({type: 'error', title: response.data.reasonText})
        }
      })
      .catch(e => {
        this.$swal({type: 'error', title: e.message})
      })
      this.dialog.dialogProgress = false
    },
    ExportExcelLab () {
      console.log('ExportExcelLab')
      console.log(this.vDataTable.data.length, 'this.vDataTable.data.length')
      if (this.vDataTable.data.length >= 0) {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        console.log(this.vDataTable.data)
        this.axios.post(process.env.VUE_APP_API + '/wp_order_item/ExportExcel', {data_json: this.vDataTable.data}
        ).then(response => {
          if (response.data.isSuccess) {
            const url = window.URL.createObjectURL(new Blob([Base64Binary.decode(response.data.excel_base64)], {type: 'application/vnd.ms-excel; charset=utf-8'}))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'export_excel_order_item.xlsx')
            document.body.appendChild(link)
            link.click()
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      } else {
        var messageCustom = 'No Data.'
        this.$swal({type: 'error', html: messageCustom})
      }
      this.dialog.dialogProgress = false
    },
    async retrieveWpLaboratory (appName) {
      await this.axios.post(process.env.VUE_APP_API + '/wp_laboratory/retrieveWpLaboratory' + process.env.VUE_APP_DATABASE_TYPE, {
        app_name: appName
      })
      .then(response => {
        if (response.data.isSuccess) {
          this.laboratoryList = response.data.data
        } else {
          this.$swal({type: 'error', title: response.data.reasonText})
        }
      })
      .catch(e => {
        this.$swal({type: 'error', title: e.message})
      })
      console.log(this.laboratoryList, 'test')
    }
  },
}
</script>
<style scoped>
.style-1 {
  color: rgb(215, 44, 44);
}
.style-2 {
  color: rgb(114,114,67);
}
.sticky-table-footer td {
  font-weight: bold;
  position: sticky;
  bottom: 0;
  background-color: #f8f8f8;
  border-top: thin solid rgba(0,0,0,.12);
}
#vue-editorOrganGrossCustomHeight200 {
  font-family: Arial, Helvetica, sans-serif;
  width: 768px;
  height: 200px;
  caret-color: black;
}
</style>